// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var OptionGroup$ReactHooksTemplate = require("../common/optionGroup.res.js");
var RatingGroup$ReactHooksTemplate = require("./RatingGroup.res.js");
var LogicCondition$ReactHooksTemplate = require("./LogicCondition.res.js");
var NumberCondition$ReactHooksTemplate = require("./NumberCondition.res.js");
var DateConditionForm$ReactHooksTemplate = require("./DateConditionForm.res.js");
var FilteredSelectBox$ReactHooksTemplate = require("./FilteredSelectBox.res.js");
var ListConditionForm$ReactHooksTemplate = require("./ListConditionForm.res.js");
var NumberConditionForm$ReactHooksTemplate = require("./NumberConditionForm.res.js");
var StringConditionForm$ReactHooksTemplate = require("./StringConditionForm.res.js");

function ConditionForm(props) {
  var __allowSentimentAttribute = props.allowSentimentAttribute;
  var updateLogicCondition = props.updateLogicCondition;
  var condition = props.condition;
  var lhsOptions = props.lhsOptions;
  var allowSentimentAttribute = __allowSentimentAttribute !== undefined ? __allowSentimentAttribute : false;
  var updateCondition = function (conditionType) {
    Curry._1(updateLogicCondition, LogicCondition$ReactHooksTemplate.setConditionType(condition, conditionType));
  };
  var shouldCoerceSentimentToAnswerText = !allowSentimentAttribute && LogicCondition$ReactHooksTemplate.isSentimentCondition(condition);
  React.useEffect((function (param) {
          if (shouldCoerceSentimentToAnswerText) {
            var question = LogicCondition$ReactHooksTemplate.lhs(condition);
            if (question.TAG === "Question") {
              var question$1 = question._0;
              var match = Question$ReactHooksTemplate.questionType(question$1);
              if (match.TAG === "LongText") {
                Curry._1(updateLogicCondition, LogicCondition$ReactHooksTemplate.emptyCondition(Caml_option.some(condition.id), undefined, {
                          TAG: "Question",
                          _0: question$1
                        }));
              }
              
            }
            
          }
          
        }), [shouldCoerceSentimentToAnswerText]);
  var renderConditionTypeForm = function (condition) {
    var x = LogicCondition$ReactHooksTemplate.conditionType(condition);
    switch (x.TAG) {
      case "NumberCondition" :
          return JsxRuntime.jsx(NumberConditionForm$ReactHooksTemplate.make, {
                      numberCondition: x._0,
                      updateCondition: updateCondition
                    });
      case "StringCondition" :
          return JsxRuntime.jsx(StringConditionForm$ReactHooksTemplate.make, {
                      stringCondition: x._0,
                      updateCondition: updateCondition
                    });
      case "ListCondition" :
          return JsxRuntime.jsx(ListConditionForm$ReactHooksTemplate.make, {
                      listCondition: x._0,
                      updateCondition: updateCondition
                    });
      case "DateCondition" :
          return JsxRuntime.jsx(DateConditionForm$ReactHooksTemplate.make, {
                      dateCondition: x._0,
                      updateCondition: updateCondition
                    });
      
    }
  };
  var questionOptions = {
    TAG: "Questions",
    _0: Belt_List.flatten(Belt_List.mapWithIndex(Belt_List.keepMap(lhsOptions, (function (item) {
                    if (item.TAG === "Question") {
                      return item._0;
                    }
                    
                  })), (function (i, q) {
                var ratingGroup = Question$ReactHooksTemplate.questionType(q);
                if (ratingGroup.TAG !== "RatingGroup") {
                  return {
                          hd: [
                            {
                              TAG: "Question",
                              _0: q
                            },
                            {
                              TAG: "HtmlElement",
                              _0: OptionGroup$ReactHooksTemplate.optionLabelElement("Q" + String(i + 1 | 0), Utils$ReactHooksTemplate.stripHtml(Question$ReactHooksTemplate.text(q)))
                            }
                          ],
                          tl: /* [] */0
                        };
                }
                var question_0 = [
                  {
                    TAG: "Question",
                    _0: q
                  },
                  {
                    TAG: "HtmlElement",
                    _0: OptionGroup$ReactHooksTemplate.optionLabelElement("Q" + String(i + 1 | 0), Utils$ReactHooksTemplate.stripHtml(Question$ReactHooksTemplate.text(q)))
                  }
                ];
                var question = {
                  hd: question_0,
                  tl: /* [] */0
                };
                return Belt_List.concat(question, Belt_List.mapWithIndex(RatingGroup$ReactHooksTemplate.groups(ratingGroup._0), (function (index, param) {
                                  return [
                                          {
                                            TAG: "SubQuestion",
                                            _0: q,
                                            _1: param[0]
                                          },
                                          {
                                            TAG: "HtmlElement",
                                            _0: OptionGroup$ReactHooksTemplate.optionLabelElement("Q" + String(i + 1 | 0) + ":" + String(index + 1 | 0), param[1])
                                          }
                                        ];
                                })));
              })))
  };
  var dataFieldOptions = {
    TAG: "DataFields",
    _0: Belt_List.mapWithIndex(Belt_List.keepMap(lhsOptions, (function (item) {
                if (item.TAG === "Question") {
                  return ;
                } else {
                  return Caml_option.some(item._0);
                }
              })), (function (i, d) {
            return [
                    d,
                    {
                      TAG: "HtmlElement",
                      _0: OptionGroup$ReactHooksTemplate.optionLabelElement("D" + String(i + 1 | 0), DataField$ReactHooksTemplate.name(d))
                    }
                  ];
          }))
  };
  var options = Belt_List.keep({
        hd: questionOptions,
        tl: {
          hd: dataFieldOptions,
          tl: /* [] */0
        }
      }, (function (opt) {
          return opt._0 !== /* [] */0;
        }));
  var question = LogicCondition$ReactHooksTemplate.lhs(condition);
  var selectedOptions;
  if (question.TAG === "Question") {
    var question$1 = question._0;
    if (questionOptions.TAG === "Questions") {
      var xs = questionOptions._0;
      var match = Question$ReactHooksTemplate.questionType(question$1);
      selectedOptions = match.TAG === "RatingGroup" ? ({
            TAG: "Questions",
            _0: Belt_List.keep(xs, (function (param) {
                    var x = param[0];
                    var x$1 = LogicCondition$ReactHooksTemplate.conditionType(condition);
                    var groupId;
                    groupId = x$1.TAG === "NumberCondition" ? NumberCondition$ReactHooksTemplate.groupId(x$1._0) : undefined;
                    if (groupId !== undefined) {
                      if (x.TAG === "Question") {
                        return false;
                      } else {
                        return groupId === x._1;
                      }
                    } else if (x.TAG === "Question") {
                      return Caml_obj.equal(Question$ReactHooksTemplate.uuid(question$1), Question$ReactHooksTemplate.uuid(x._0));
                    } else {
                      return false;
                    }
                  }))
          }) : ({
            TAG: "Questions",
            _0: Belt_List.keep(xs, (function (param) {
                    return Caml_obj.equal(Question$ReactHooksTemplate.uuid(question$1), Question$ReactHooksTemplate.uuid(param[0]._0));
                  }))
          });
    } else {
      selectedOptions = {
        TAG: "Questions",
        _0: /* [] */0
      };
    }
  } else {
    var dataField = question._0;
    selectedOptions = dataFieldOptions.TAG === "DataFields" ? ({
          TAG: "DataFields",
          _0: Belt_List.keep(dataFieldOptions._0, (function (param) {
                  return Caml_obj.equal(DataField$ReactHooksTemplate.id(dataField), DataField$ReactHooksTemplate.id(param[0]));
                }))
        }) : ({
          TAG: "DataFields",
          _0: /* [] */0
        });
  }
  var handleLhsQuestionChange = function (updatedOptions) {
    var tmp;
    switch (updatedOptions.TAG) {
      case "Questions" :
          var match = Belt_List.head(updatedOptions._0);
          if (match !== undefined) {
            var q = match[0];
            tmp = q.TAG === "Question" ? LogicCondition$ReactHooksTemplate.emptyCondition(Caml_option.some(condition.id), undefined, {
                    TAG: "Question",
                    _0: q._0
                  }) : LogicCondition$ReactHooksTemplate.emptyCondition(Caml_option.some(condition.id), Caml_option.some(q._1), {
                    TAG: "Question",
                    _0: q._0
                  });
          } else {
            tmp = condition;
          }
          break;
      case "DataFields" :
          var match$1 = Belt_List.head(updatedOptions._0);
          tmp = match$1 !== undefined ? LogicCondition$ReactHooksTemplate.emptyCondition(Caml_option.some(condition.id), undefined, {
                  TAG: "DataField",
                  _0: match$1[0]
                }) : condition;
          break;
      default:
        tmp = condition;
    }
    Curry._1(updateLogicCondition, tmp);
  };
  var longTextAttributeValue = LogicCondition$ReactHooksTemplate.isSentimentCondition(condition) ? "sentiment" : "text";
  var handleLongTextAttributeChange = function ($$event) {
    var attribute = Utils$ReactHooksTemplate.formTargetValue($$event);
    var question = LogicCondition$ReactHooksTemplate.lhs(condition);
    if (question.TAG !== "Question") {
      return ;
    }
    var question$1 = question._0;
    var match = Question$ReactHooksTemplate.questionType(question$1);
    if (match.TAG !== "LongText") {
      return ;
    }
    var tmp;
    var exit = 0;
    if (attribute === "sentiment" && allowSentimentAttribute) {
      tmp = LogicCondition$ReactHooksTemplate.emptySentimentCondition(Caml_option.some(condition.id), question$1);
    } else {
      exit = 1;
    }
    if (exit === 1) {
      tmp = LogicCondition$ReactHooksTemplate.emptyCondition(Caml_option.some(condition.id), undefined, {
            TAG: "Question",
            _0: question$1
          });
    }
    Curry._1(updateLogicCondition, tmp);
  };
  var renderLongTextAttributeSelector = LogicCondition$ReactHooksTemplate.isLongTextQuestionLhs(condition) && allowSentimentAttribute ? Caml_option.some(JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: "Attribute",
                      className: "h-20-px font-normal text-xs text-aurometalsaurus"
                    }),
                JsxRuntime.jsxs("select", {
                      children: [
                        JsxRuntime.jsx("option", {
                              children: "Answer Text",
                              value: "text"
                            }),
                        JsxRuntime.jsx("option", {
                              children: "Sentiment",
                              value: "sentiment"
                            })
                      ],
                      className: "min-h-38-px px-2 py-1 rounded bg-white border border-gray-300\n                         cursor-pointer focus:border-gray-600 text-xs",
                      value: longTextAttributeValue,
                      onChange: handleLongTextAttributeChange
                    })
              ],
              className: "flex flex-col w-3/12 flex-shrink-0"
            })) : undefined;
  var tmp;
  switch (selectedOptions.TAG) {
    case "DataFields" :
        tmp = "Data Field";
        break;
    default:
      tmp = "Question/Data Field";
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: "IF",
                      className: "flex text-base font-semibold text-darkcharcoal w-1/12 pt-20-px items-start flex-shrink-0"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: tmp,
                                    className: "h-20-px font-normal text-xs text-aurometalsaurus"
                                  }),
                              JsxRuntime.jsx(FilteredSelectBox$ReactHooksTemplate.make, {
                                    options: options,
                                    placeholder: "select question/data field",
                                    onChange: handleLhsQuestionChange,
                                    className: "py-1 px-2 rounded bg-white border cursor-pointer\n                      border-gray-300 focus:border-gray-600 text-xs min-h-38-px",
                                    selectedOption: selectedOptions
                                  })
                            ],
                            className: "flex flex-col w-full min-w-0"
                          }),
                      className: "flex w-4/12 min-w-0"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        renderLongTextAttributeSelector !== undefined ? Caml_option.valFromOption(renderLongTextAttributeSelector) : null,
                        JsxRuntime.jsx("div", {
                              children: renderConditionTypeForm(condition),
                              className: "flex-1 min-w-0"
                            })
                      ],
                      className: "flex items-start gap-2 w-7/12 min-w-0"
                    })
              ],
              className: "flex gap-2 w-full items-start min-w-0"
            });
}

var make = ConditionForm;

exports.make = make;
/* react Not a pure module */
